import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    label: {
      font: scssVariables.FontBodyRegular,
      display: 'inline-flex',
    },
    root: {
      minWidth: '32px', // force chips to be round when short content
      variants: [
        {
          props: { size: 'small' },
          style: {
            '& .MuiChip-label': {
              font: 'var(--font-label)',
            },
          },
        },
        {
          props: {
            color: 'purple',
          },
          style: {
            backgroundColor: scssVariables.ColorPurple20,
            color: scssVariables.ColorPurple80,
            '& .MuiChip-deleteIcon': {
              color: scssVariables.ColorPurple80,
            },
          },
        },
        {
          props: {
            color: 'fog',
          },
          style: {
            backgroundColor: scssVariables.ColorFog20,
            color: scssVariables.ColorFog100,
            '& .MuiChip-deleteIcon': {
              color: scssVariables.ColorFog100,
            },
          },
        },
        {
          props: {
            color: 'coral',
          },
          style: {
            backgroundColor: scssVariables.ColorCoral20,
            color: scssVariables.ColorCoral80,
            '& .MuiChip-deleteIcon': {
              color: scssVariables.ColorCoral80,
            },
          },
        },
        {
          props: {
            color: 'maroon',
          },
          style: {
            backgroundColor: scssVariables.ColorMaroon20,
            color: scssVariables.ColorMaroon80,
            '& .MuiChip-deleteIcon': {
              color: scssVariables.ColorMaroon80,
            },
          },
        },
        {
          props: {
            color: 'blue',
          },
          style: {
            '&.MuiChip-filled': {
              backgroundColor: scssVariables.ColorBlue10,
              color: scssVariables.ColorBlue100,

              '& .MuiChip-deleteIcon': {
                color: scssVariables.ColorBlue100,
              },
            },
            '&.MuiChip-outlined': {
              backgroundColor: scssVariables.ColorBlue10,
              borderColor: scssVariables.ColorBlue80,
              color: scssVariables.ColorBlue80,

              '& .MuiChip-deleteIcon': {
                color: scssVariables.ColorBlue80,
              },
            },
          },
        },
        {
          props: {
            color: 'navy',
          },
          style: {
            '&.MuiChip-filled': {
              backgroundColor: scssVariables.ColorNavy10,
              color: scssVariables.ColorNavy100,

              '& .MuiChip-deleteIcon': {
                color: scssVariables.ColorNavy100,
              },
            },
            '&.MuiChip-outlined': {
              backgroundColor: scssVariables.ColorNavy10,
              borderColor: scssVariables.ColorNavy100,
              color: scssVariables.ColorNavy100,

              '& .MuiChip-deleteIcon': {
                color: scssVariables.ColorNavy100,
              },
            },
          },
        },
        {
          props: { monoText: true },
          style: {
            '& .MuiChip-label': {
              fontFamily: scssVariables.FontFamilyMono,
            },
          },
        },
      ],
    },
    colorDefault: {
      backgroundColor: scssVariables.ColorBlack80,
      color: scssVariables.ColorBlack10,

      '&.MuiChip-outlined': {
        backgroundColor: scssVariables.ColorBlack10,
        color: scssVariables.ColorBlack60,
        borderColor: scssVariables.ColorBlack60,

        '&.MuiChip-clickable:hover': {
          backgroundColor: scssVariables.ColorBlack20,
        },
      },
    },
    colorError: {
      backgroundColor: scssVariables.ColorError10,
      color: scssVariables.ColorError100,
    },
    colorWarning: {
      backgroundColor: scssVariables.ColorWarning10,
      color: scssVariables.ColorWarning100,
    },
    colorInfo: {
      backgroundColor: scssVariables.ColorInfo10,
      color: scssVariables.ColorInfo100,
    },
    colorSuccess: {
      backgroundColor: scssVariables.ColorSuccess10,
      color: scssVariables.ColorSuccess100,
    },
  },
};
